/**
 * @Author: v_jppjpeng
 * @Date: 2023-2-9 09:48:13
 * @Explain: 占位符管理
 */

export default {
  // 列表
  'PLACEHOLDER.MANAGE.LIST.TITLE': 'Placeholders list',
  'PLACEHOLDER.MANAGE.TIPS2.TITLE': 'Replace with static value',
  'PLACEHOLDER.MANAGE.TIPS3.TITLE': 'Replace with dynamic value',
  'PLACEHOLDER.MANAGE.TIPS1':
    'You can create a keys, insert it into the template, and send it randomly to contacts as part of an campaign.',
  'PLACEHOLDER.MANAGE.TIPS2':
    'Exhausting the keys may lead to campaign anomalies. After applying the keys to an campaign, ensure that there are sufficient remaining codes.',
  'PLACEHOLDER.MANAGE.TIPS3':
    'This key will be replaced with dynamic real-time query values, such as personal information or in-game information. Examples are birthdays, country, language, character nickname, win ratio, etc.',
  'PLACEHOLDER.MANAGE.REPLACE.WITH.FIXED.VALUE': 'Static values',
  'PLACEHOLDER.MANAGE.REPLACE.WITH.DYNAMIC.VALUE': 'Dynamic values',
  'PLACEHOLDER.MANAGE.TEMPLATE.VAR': 'Placeholders used in templates',
  'PLACEHOLDER.MANAGE.PLEASE.SELECT.TEMPLATE': 'Select template',
  'PLACEHOLDER.MANAGE.SEARCH.PLACEHOLDER': 'Search keys',
  'PLACEHOLDER.MANAGE.NAME': 'Pool name',
  'PLACEHOLDER.MANAGE.AMOUNT.OF.VALUES': 'Number of values',
  'PLACEHOLDER.MANAGE.USED': 'Used',
  'PLACEHOLDER.MANAGE.REAMAINING': 'Available',
  'PLACEHOLDER.MANAGE.USAGE': 'Values used',
  'PLACEHOLDER.MANAGE.VALUE.TO.REPLACE.WITH': 'Values to replace with',
  'PLACEHOLDER.MANAGE.DEFAULT.VALUE': 'Default Value',
  'PLACEHOLDER.MANAGE.EXPORT.DETAILS': 'Export Details',
  'PLACEHOLDER.MANAGE.PLATFORM': 'Platform',
  'PLACEHOLDER.MANAGE.DISTRIBUTE.PROGRESS': 'Distribute Progress',
  'PLACEHOLDER.MANAGE.IMPORT': 'Import',

  // 删除
  'PLACEHOLDER.MANAGE.DEL.TITLE': 'Delete key',
  'PLACEHOLDER.MANAGE.DEL.DESC':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",

  // 详情
  'PLACEHOLDER.MANAGE.BASIC.INFO': 'Basic information',
  'PLACEHOLDER.MANAGE.TYPE': 'Type',
  'PLACEHOLDER.MANAGE.AMOUNT': 'Amount',
  'PLACEHOLDER.MANAGE.DELIVERY.STATUS': 'Delivery status',
  'PLACEHOLDER.MANAGE.CAMPAIGNS': 'Campaigns',
  'PLACEHOLDER.MANAGE.CAMPAIGN': 'Campaign/Journey',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Campaign': 'Campaign',
  'PLACEHOLDER.MANAGE.CLASSIFICATION.JOUNEY': 'Journey',
  'PLACEHOLDER.MANAGE.AVAILIBLE.IN.POLL': 'Avalible / In pool',
  'PLACEHOLDER.MANAGE.CLASSIFICATION.EMAIL.CAMPAIGN': 'Email campaign',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Double.OptIn.Email': 'Double opt-in email',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Form': 'Form',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.SelectedTemplates': 'Templates',
  'PLACEHOLDER.MANAGE.PROGRESS.OF.DELIEVERY': 'Delivery progress',
  'PLACEHOLDER.MANAGE.SEARCH.FOR.THE.VALUE': 'Search for specific value',
  'PLACEHOLDER.MANAGE.SEARCH.VALUE.EMAIL': 'Enter value name or email addr.',
  'PLACEHOLDER.MANAGE.PLACEHOLDER': 'Placeholder',
  'PLACEHOLDER.MANAGE.VALUE': 'Key',
  'PLACEHOLDER.MANAGE.PROGRESS.LABEL':
    '<span style="color: rgba(255, 255, 255, 0.7);">Distributed</span> {molecule} / <span style="color: rgba(255, 255, 255, 0.7);">Total</span> {denominator}',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.BY.ACTIVITY': 'Distribution by Activity',
  'PLACEHOLDER.MANAGE.ACTIVITIES': 'Activities',
  'PLACEHOLDER.MANAGE.ACTIVITIES.SEARCH.PLACEHOLDER': 'Search activity name',
  'PLACEHOLDER.MANAGE.ACTIVITY.NAME': 'Name',
  'PLACEHOLDER.MANAGE.RATE': 'Rate',
  'PLACEHOLDER.MANAGE.IMPORT.DATE': 'Import date',
  'PLACEHOLDER.MANAGE.USER.EMAIL': 'Distributed to',
  'PLACEHOLDER.MANAGE.DELIVER.TIME': 'Distribute date',
  'PLACEHOLDER.MANAGE.AVAILABLE': 'Available',
  'PLACEHOLDER.MANAGE.DISTRIBUTED': 'Distributed',

  'PLACEHOLDER.MANAGE.LI.PASS.EMAIL': 'LEVEL INFINITE PASS welcome email',
  'PLACEHOLDER.MANAGE.CONTACTS.WELCOME.EMAIL':
    'Contacts from API source-welcome email',
  'PLACEHOLDER.MANAGE.Export': 'Export',
  'PLACEHOLDER.MANAGE.Export.SUCCESS':
    'Export task submitted successfully. Please go to the <span class="color-primary">Export Center</span> to download the file.',
  'PLACEHOLDER.MANAGE.Export.FAILED': 'Export failed, please retry.',
  'PLACEHOLDER.MANAGE.Export.DIALOG.HEADER':
    'Confirm export of resource code details?',
  'PLACEHOLDER.MANAGE.Export.DIALOG.CHILDREN':
    'Once confirmed, an export task will be created in the Export Center. The export process will take some time, and you will receive an email notification upon completion.<br/>Note: When contacts are sourced exclusively from LEVEL INFINITE PASS, only encrypted email addresses can be exported.',

  // 模板变量 - 新增、编辑
  'PLACEHOLDER.MANAGE.CREATE.PLACEHOLDER': 'Create key pool',
  'PLACEHOLDER.MANAGE.EDIT.PLACEHOLDER': 'Edit key pool',
  'PLACEHOLDER.MANAGE.IMPORT.PLACEHOLDER': 'Import keys',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.NAME': 'Key Name',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.CreateKeysTips':
    'The keys created here can be inserted into templates. The key values need to be imported in advance. This is applicable for randomly sending gift codes, promotional codes, and redemption codes to users.',
  'PLACEHOLDER.MANAGE.PLEASE.ENTER.PLACEHOLDER.NAME':
    'Please enter the Key pool name.',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLATFORM': 'Distribution platform',
  'PLACEHOLDER.MANAGE.STEAM': 'Steam',
  'PLACEHOLDER.MANAGE.KEY.POOL.NAME': 'Key pool name',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLATFORM.PLACHOLDER': 'Select platform',
  'PLACEHOLDER.MANAGE.DISTRIBUTION': 'Description',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLACHOLDER':
    'E.g., Steam Beta Keys for Q4 Marketing Campaign (Batch 2025-01)',
  'PLACEHOLDER.MANAGE.KEY.CONTENT.TYPE': 'Key Content',
  'PLACEHOLDER.MANAGE.BASE.GAME': 'Base game',
  'PLACEHOLDER.MANAGE.DLC': 'DLC',
  'PLACEHOLDER.MANAGE.PLAYTEST': 'Playtest',
  'PLACEHOLDER.MANAGE.TARGET.STEAM.APP.ID': 'Target Steam App ID',
  'PLACEHOLDER.MANAGE.TARGET.BASE.GAME.ID': 'Target Base game ID',
  'PLACEHOLDER.MANAGE.TARGET.DLC.APP.ID': 'Target DLC App ID',
  'PLACEHOLDER.MANAGE.ITEM.ID': 'Item ID',
  'PLACEHOLDER.MANAGE.IDS.MESSAGE': 'You can use numbers, letters',
  'PLACEHOLDER.MANAGE.SAVE.AND.IMPORT': 'Save & Import keys',
  'PLACEHOLDER.MANAGE.FILE.SUMMART': 'Import summary',
  'PLACEHOLDER.MANAGE.FILE.PASS.TIPS':
    '{num} keys are valid and ready to be added.',
  'PLACEHOLDER.MANAGE.FILE.FORMAT.ERROR':
    '{num} keys have unusual formats but can be imported.',
  'PLACEHOLDER.MANAGE.FILE.REPEAT.ERROR':
    '{num} keys were skipped due to errors or duplicates.',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.TYPE': 'Placeholder type',
  'PLACEHOLDER.MANAGE.FIXED.VALUE': 'Static value',
  'PLACEHOLDER.MANAGE.DYNAMIC.VALUE': 'Dynamic value',
  'PLACEHOLDER.MANAGE.FIXED.VALUE.TIPS':
    'This key will be replaced with static offline values, such as gift codes, promotional codes, redemption codes. These values will need to be imported in advance.',
  'PLACEHOLDER.MANAGE.UPLOAD.VALUES': 'Upload static values',
  'PLACEHOLDER.MANAGE.PLEASE.UPLOAD.DYNAMIC.VAR.FILE': 'Upload dynamic values',
  'PLACEHOLDER.MANAGE.SELECT.REPLACE.VALUE':
    'Select the value this key will be replaced with',
  'PLACEHOLDER.MANAGE.PERSONAL.INFO': 'Personal information',
  'PLACEHOLDER.MANAGE.SET.DEFAULT.VALUE': 'Set the default value',
  'PLACEHOLDER.MANAGE.PLEASE.ENTER.DEFAULT.VALUE': 'Enter default value',
  'PLACEHOLDER.MANAGE.DEFAULT.VALUE.TIPS':
    'The default value will be shown when the dynamic value query fails.',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1':
    'Drag and drop your file here (.xlxs), or ',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1-1': 'click',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1-2': ' to upload.',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-3':
    'File needs to be encoded in UTF-8 format',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-1':
    'Import values from a xlxs or csv file.Import is limitid to {size}.',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-2':
    'For larger lists, please split your file into smaller ones and upload them separately.',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS3':
    '{total} values in total. The campaign will stop running once all values have been sent out.',
  'PLACEHOLDER.MANAGE.TIP':
    '*SmartLink will automatically remove duplicate values',

  // 标题
  'PLACEHOLDER.MANAGE.TITLE': 'Select key/ contact attribute',
  'PLACEHOLDER.MANAGE.TITLE.WHATSAPP': 'Select contact attribute',
  // 资源码
  'PLACEHOLDER.MANAGE.RESOURCE.CODE': 'Key',
  // 动态码
  'PLACEHOLDER.MANAGE.DYNAMIC.CODE': 'Dynamic code',
  // 联系人字段
  'PLACEHOLDER.MANAGE.CONTACT.FIELD': 'Contact attribute',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.NAME.TIP':
    'Only one variable can be inserted here',
  // 创建资源码
  'PLACEHOLDER.MANAGE.CREATE.KEYS.DOWNLOAD': 'Download an template',
};
